import { render, staticRenderFns } from "./CosmoClawMessageRail.vue?vue&type=template&id=73abfd86&scoped=true"
import script from "./CosmoClawMessageRail.vue?vue&type=script&lang=js"
export * from "./CosmoClawMessageRail.vue?vue&type=script&lang=js"
import style0 from "./CosmoClawMessageRail.vue?vue&type=style&index=0&id=73abfd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73abfd86",
  null
  
)

export default component.exports